export const DEFAULT_THEME_FILTERS = Object.freeze({
  query: '',
  sort: 'popular',
  type: 'all',
  ownership: 'all',
});

const SORTS = new Set(['popular', 'new', 'price_asc', 'price_desc']);
const TYPES = new Set(['all', 'photo', 'gif', 'video']);
const OWNERSHIP = new Set(['all', 'buy', 'owned']);

export function normalizeThemeFilters(filters = {}) {
  return {
    query: String(filters.query || '').trim().slice(0, 80),
    sort: SORTS.has(filters.sort) ? filters.sort : DEFAULT_THEME_FILTERS.sort,
    type: TYPES.has(filters.type) ? filters.type : DEFAULT_THEME_FILTERS.type,
    ownership: OWNERSHIP.has(filters.ownership) ? filters.ownership : DEFAULT_THEME_FILTERS.ownership,
  };
}

export function detectThemeType(theme = {}) {
  const declared = String(theme.media_type || '').toLowerCase();
  if (declared === 'video' || declared === 'gif' || declared === 'photo') return declared;
  const media = String(theme.media_url || '').split('?')[0].toLowerCase();
  if (media.endsWith('.mp4') || media.endsWith('.webm')) return 'video';
  if (media.endsWith('.gif')) return 'gif';
  return 'photo';
}

function createdAt(theme) {
  const raw = theme?.created_at;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  const parsed = Date.parse(String(raw || ''));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function filterThemes(themes, filters, context = {}) {
  const state = normalizeThemeFilters(filters);
  const owned = new Set((context.ownedIds || []).map(String));
  const userId = String(context.userId || '');
  const query = state.query.toLocaleLowerCase('ru-RU');

  const result = (Array.isArray(themes) ? themes : [])
    .filter(theme => theme && theme.id != null)
    .filter(theme => {
      if (state.type !== 'all' && detectThemeType(theme) !== state.type) return false;
      const isOwned = owned.has(String(theme.id)) || (userId && String(theme.author_id || '') === userId);
      if (state.ownership === 'owned' && !isOwned) return false;
      if (state.ownership === 'buy' && isOwned) return false;
      if (!query) return true;
      return `${theme.title || ''} ${theme.author_name || ''}`.toLocaleLowerCase('ru-RU').includes(query);
    });

  return result.sort((a, b) => {
    if (state.sort === 'price_asc') return Number(a.price || 0) - Number(b.price || 0);
    if (state.sort === 'price_desc') return Number(b.price || 0) - Number(a.price || 0);
    if (state.sort === 'new') return createdAt(b) - createdAt(a);
    return Number(b.sales || 0) - Number(a.sales || 0) || createdAt(b) - createdAt(a);
  });
}

export function hasActiveThemeFilters(filters) {
  const state = normalizeThemeFilters(filters);
  return state.query !== '' || state.sort !== 'popular' || state.type !== 'all' || state.ownership !== 'all';
}
